import {
  buildAttachments,
  buildEmailList,
  buildLegacyInterviews,
  buildNumberValue,
  mapCancelEmailToSendEmail
} from './SendoutForm.utils';

export const FORM_FIELDS_MAP = {
  AccountableRecruiter: {
    key: 'accountableRecruiter',
    paramKey: 'job_order_accountable_id',
    outboundAccesor: 'id'
  },
  Candidate: {
    key: 'candidate',
    paramKey: 'candidate_id',
    outboundAccesor: 'id'
  },
  CandidateRecruiter: {
    key: 'candidateRecruiter',
    paramKey: 'candidate_accountable_id',
    outboundAccesor: 'id'
  },
  EstimatedFeeAmount: {
    key: 'estimatedFeeAmount',
    paramKey: 'fee_amount',
    outboundAccesor: buildNumberValue
  },
  InterviewType: {
    key: 'interviewType'
  },
  InterviewDate: {
    key: 'interviewDate'
  },
  InterviewTime: {
    key: 'interviewTime'
  },
  InterviewTimeFrame: {
    key: 'interviewTimeFrame'
  },
  InterviewFromHour: {
    key: 'interviewFromHour'
  },
  InterviewToHour: {
    key: 'interviewToHour'
  },
  InterviewAddress: {
    key: 'interviewAddress'
  },
  InterviewLink: {
    key: 'interviewLink'
  },
  InterviewTimezone: {
    key: 'interviewTimezone'
  },
  CandidateTwentyFourHoursReminder: {
    key: 'candidateTwentyFourHoursReminder'
  },
  HiringAuthorityTwentyFourHoursReminder: {
    key: 'hiringAuthorityTwentyFourHoursReminder'
  },
  CandidateOneHourReminder: {
    key: 'candidateOneHourReminder'
  },
  HiringAuthorityOneHourReminder: {
    key: 'hiringAuthorityOneHourReminder'
  },
  HiringAuthority: {
    key: 'hiringAuthority',
    paramKey: 'hiring_authority'
  },
  CancelEmailToHiringAuthority: {
    key: 'cancelEmailToHiringAuthority',
    paramKey: 'send_email',
    outboundAccesor: mapCancelEmailToSendEmail
  },
  CarbonCopy: {
    key: 'carbonCopy',
    paramKey: 'cc_emails',
    outboundAccesor: buildEmailList
  },
  BlindCarbonCopy: {
    key: 'blindCarbonCopy',
    paramKey: 'bcc_emails',
    outboundAccesor: buildEmailList
  },
  Attachments: {
    key: 'attachments',
    paramKey: 'attachments',
    outboundAccesor: buildAttachments
  },
  Interviews: {
    key: 'interviews',
    paramKey: 'interviews',
    outboundAccesor: buildLegacyInterviews
  },
  EmailSubject: {
    key: 'emailSubject',
    paramKey: 'subject'
  },
  EmailBody: {
    key: 'emailBody'
  },
  ResolvedEmailBody: {
    key: 'resolvedEmailBody'
  }
};
